import { defineComponent } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import { NoVisaRequiredCB } from './NoVisaRequiredCB';

export default defineComponent({
	setup: () => {
		const codeBehind = new NoVisaRequiredCB();

		return setupComponent(codeBehind);
	},
});
